var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-nav',{ref:"headerNav",attrs:{"navList":_vm.navList}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('other-icon'),_c('footer-nav',{ref:"footerNav",attrs:{"navList":_vm.navList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }